// ============================================================================
// REACT ROUTER V6 — DATA API ROUTER
// ARQUIVO: src/app/router.jsx
// RESPONSABILIDADE: Definição declarativa de todas as rotas via createBrowserRouter.
// App.jsx agora é apenas o hospedeiro do <RouterProvider />.
// ============================================================================

import { createBrowserRouter, Navigate } from 'react-router-dom';
import AppContent from './AppContent';

const router = createBrowserRouter(
  [
    {
      path: '*',
      element: <AppContent />,
    },
    {
      path: '/admin',
      element: <AppContent />,
      children: [
        { index: true, element: <Navigate to="/admin/home" replace /> },
        { path: ':tab', element: <AppContent /> },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

export default router;
